import createReducer from 'redux/lib/reducerConfig';
import { PRICING_OPTIONS } from 'components/MarketPrice/Filter/PricingStatusSelector';
import { ActionTypes as SharedActionTypes, sharedPages } from 'redux/marketPrice/sharedFilter';
import { PricedStatus, SurveyJobSearchField } from 'types';
import { selectDefaultPlans } from '../selectors';

const ActionTypes = {
  SET_FILTER: 'MARKET_PRICE/SET_FILTER',
  RESET_FILTER: 'MARKET_PRICE/RESET_FILTER',
};

export const filterInitialState = {
  plan: [],
  payMarket: [],
  jobFamily: [],
  jobSubFamily: [],
  jobLevel: [],
  tags: [],
  priced: PRICING_OPTIONS.all.value,
  search: [],
  searchFields: Object.values(SurveyJobSearchField),
  effectiveDate: null,
  grade: [],
  salaryRangeTypeOfPay: [],
};

export const setFilter = (filter) => ({
  type: ActionTypes.SET_FILTER,
  payload: filter,
});

export const resetFilter = () => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.RESET_FILTER,
    payload: {
      ...filterInitialState,
      plan: selectDefaultPlans(getState()),
    },
  });
};

export const filterReducer = createReducer(
  filterInitialState,
  {
    [ActionTypes.SET_FILTER]: (state, { payload }) => {
      return payload;
    },
    [ActionTypes.RESET_FILTER]: (state, { payload }) => {
      return payload;
    },
    [SharedActionTypes.SET_SHARED_FILTER]: (state, { payload, page }) => {
      if (page !== sharedPages.mass && page !== sharedPages.single) {
        return { ...state, ...payload };
      }

      if (state.priced !== PricedStatus.ALL) {
        return { ...state, priced: PricedStatus.ALL };
      }

      return state;
    },
  },
);
